import { useTargetBrandConfig } from 'FrontRoyalAngular';

export const useProjectImage = () => {
    const brandConfig = useTargetBrandConfig();

    return brandConfig.avatarGradient || brandConfig.avatarDefault || brandConfig.avatarAlt!;
};
